module.exports = __webpack_public_path__ + "static/media/inactive trophy.a0e0d008.png";